"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popularDataQuery = void 0;
var _fetching = require("@ori/fetching");
var _fragments = require("./fragments");
/* istanbul ignore file  -- query */

const popularDataQuery = exports.popularDataQuery = (0, _fetching.gql)`
  query PopularData($productCodes: [ID!]!) {
    products(productCodes: $productCodes) {
      ...SearchPreviewProduct
    }
  }
  ${_fragments.searchPreviewProduct}
`;
